import OBase from './OBase';
import * as Geometry from '../geometry';
import * as GHMath from '../../math';

export default class XYPlane extends OBase {
  update () {
    let originValTree = this.getVector3Input('Origin', false);
    let output = this.getGenericObjectOutput('Plane');

    let outTree = new Geometry.DataTree();

    for (let i = 0; i < originValTree.branches.length; i++) {
      for (let j = 0; j < originValTree.branches[i].length; j++) {
        var path = originValTree.paths[i];
        var v = originValTree.branches[i][j];
        var plane = GHMath.XYPlane();
        plane.translate(v);
        outTree.add(plane, path);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/XYPlane.js